import React from 'react';

export const SpecialFeatures = React.lazy(() =>
  import('./SpecialFeatures').then((module) => ({ default: module.SpecialFeatures })),
);
